import { makeStyles } from 'tss-react/mui';

import { DEFAULT_MENU_PAPER_SHADOW } from 'modules/common/styles/const';

const name = 'BalanceMenu';

export const useBalanceMenuStyles = makeStyles({ name })(theme => ({
  root: {
    width: 300,
    padding: theme.spacing(6, 5),
  },
  paper: {
    borderRadius: theme.shape.borderRadius,

    boxShadow: DEFAULT_MENU_PAPER_SHADOW,
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(),

    padding: theme.spacing(),
  },
}));
